import { c as _c } from "react-compiler-runtime";
import classNames from "clsx";
import React, { useEffect, useState } from "react";
import { ProgressBar as AriaProgressbar } from "react-aria-components";
import { sky600, success500 } from "../colors.js";
import { AlertCircle } from "../icons/line.js";
import { base, errorIcon, fadeInOutAnimation, fadeOutAnimation, plainSpinner, plainSpinnerWrapper, spinner, spinnerContainer, tick } from "./Spinner.css.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const sizeMap = {
  xs: 16,
  sm: 16,
  md: 24,
  lg: 32
};
const BaseSpinner = (t0, ref) => {
  const $ = _c(44);
  let hasError;
  let isLoading;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      isLoading,
      hasError,
      sizeVariant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = hasError;
    $[2] = isLoading;
    $[3] = props;
    $[4] = t1;
  } else {
    hasError = $[1];
    isLoading = $[2];
    props = $[3];
    t1 = $[4];
  }
  const sizeVariant = t1 === undefined ? "md" : t1;
  const iconSize = sizeMap[sizeVariant];
  const [loading, setLoading] = useState(isLoading);
  const [startAnimation, setStartAnimation] = useState(false);
  let t2;
  let t3;
  if ($[5] !== hasError || $[6] !== isLoading) {
    t2 = () => {
      setStartAnimation(false);
      if (isLoading) {
        setLoading(true);
        return;
      }
      if (hasError === true) {
        setLoading(false);
        return;
      }
      setStartAnimation(true);
      const newTimer = setTimeout(() => {
        setLoading(false);
        setStartAnimation(false);
      }, 3000);
      return () => {
        clearTimeout(newTimer);
      };
    };
    t3 = [isLoading, hasError];
    $[5] = hasError;
    $[6] = isLoading;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  if (hasError === true) {
    let t4;
    if ($[9] !== sizeVariant) {
      t4 = base({
        size: sizeVariant
      });
      $[9] = sizeVariant;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    const t5 = `${iconSize.toString()}px`;
    const t6 = `${iconSize.toString()}px`;
    let t7;
    if ($[11] !== t5 || $[12] !== t6) {
      t7 = /*#__PURE__*/_jsx(AlertCircle, {
        className: errorIcon,
        height: t5,
        width: t6
      });
      $[11] = t5;
      $[12] = t6;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== props || $[15] !== ref || $[16] !== t4 || $[17] !== t7) {
      t8 = /*#__PURE__*/_jsx(AriaProgressbar, {
        className: t4,
        isIndeterminate: true,
        ref: ref,
        ...props,
        children: t7
      });
      $[14] = props;
      $[15] = ref;
      $[16] = t4;
      $[17] = t7;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    return t8;
  }
  if (!loading) {
    return null;
  }
  let t4;
  if ($[19] !== sizeVariant) {
    t4 = base({
      size: sizeVariant
    });
    $[19] = sizeVariant;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== startAnimation) {
    t5 = classNames(spinnerContainer, startAnimation && fadeOutAnimation);
    $[21] = startAnimation;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  const t6 = `${iconSize.toString()}px`;
  const t7 = `${iconSize.toString()}px`;
  let t8;
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = /*#__PURE__*/_jsx("circle", {
      cx: "8",
      cy: "8",
      r: "4",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      color: "#F2F4F7"
    });
    t9 = /*#__PURE__*/_jsx("path", {
      d: "M 8,8 m 0,-4 a 4,4 0 0,1 4,4",
      fill: "none",
      stroke: sky600,
      strokeWidth: "2",
      strokeLinecap: "round"
    });
    $[23] = t8;
    $[24] = t9;
  } else {
    t8 = $[23];
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t6 || $[26] !== t7) {
    t10 = /*#__PURE__*/_jsxs("svg", {
      width: t6,
      height: t7,
      viewBox: "0 0 16 16",
      fill: "none",
      className: spinner,
      children: [t8, t9]
    });
    $[25] = t6;
    $[26] = t7;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t5) {
    t11 = /*#__PURE__*/_jsx("div", {
      className: t5,
      children: t10
    });
    $[28] = t10;
    $[29] = t5;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const t12 = `${iconSize.toString()}px`;
  const t13 = `${iconSize.toString()}px`;
  let t14;
  if ($[31] !== startAnimation) {
    t14 = classNames(tick, startAnimation && fadeInOutAnimation);
    $[31] = startAnimation;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = /*#__PURE__*/_jsx("path", {
      d: "M13.3332 4L5.99984 11.3333L2.6665 8",
      stroke: success500,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    });
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t12 || $[35] !== t13 || $[36] !== t14) {
    t16 = /*#__PURE__*/_jsx("svg", {
      width: t12,
      height: t13,
      viewBox: "0 0 16 16",
      fill: "none",
      className: t14,
      children: t15
    });
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== props || $[39] !== ref || $[40] !== t11 || $[41] !== t16 || $[42] !== t4) {
    t17 = /*#__PURE__*/_jsxs(AriaProgressbar, {
      className: t4,
      isIndeterminate: true,
      ref: ref,
      ...props,
      children: [t11, t16]
    });
    $[38] = props;
    $[39] = ref;
    $[40] = t11;
    $[41] = t16;
    $[42] = t4;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  return t17;
};
export const Spinner = /*#__PURE__*/React.forwardRef(BaseSpinner);
export const PlainSpinner = t0 => {
  const $ = _c(9);
  const {
    size,
    color,
    loadingLabel
  } = t0;
  let t1;
  if ($[0] !== color || $[1] !== size) {
    t1 = plainSpinner({
      size,
      color
    });
    $[0] = color;
    $[1] = size;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M4.57538 4.57538C5.74706 3.4037 7.17941 2.52595 8.75532 2.01391c1.57588-.51205 3.25068-.64385 4.88728-.38464 1.6366.25922 3.1886.90209 4.5291 1.87605 1.3406.97397 2.4316 2.25138 3.1839 3.72778C22.1078 8.70951 22.5 10.343 22.5 12c0 1.657-.3922 3.2905-1.1444 4.7669-.7523 1.4764-1.8433 2.7538-3.1839 3.7278-1.3405.9739-2.8925 1.6168-4.5291 1.876"
    });
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = /*#__PURE__*/_jsx("svg", {
      fill: "none",
      viewBox: "0 0 24 24",
      className: t1,
      children: t2
    });
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== loadingLabel || $[7] !== t3) {
    t4 = /*#__PURE__*/_jsx(AriaProgressbar, {
      isIndeterminate: true,
      "aria-label": loadingLabel,
      className: plainSpinnerWrapper,
      children: t3
    });
    $[6] = loadingLabel;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
//# sourceMappingURL=Spinner.js.map